import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';

const AdminProtectedRoutes = () => {

    const [isLoading, setIsLoading] = React.useState(true);
    const [user, setUser] = React.useState(null);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setUser(JSON.parse(localStorage.getItem('user')))
            setIsLoading(false);
        }
    }, [])

    return (
        <div>
            {isLoading ? <div>Unauthourize Attempt</div> :
                <>
                    {user === 'admin' ? <Outlet /> : <Navigate to='/' />}
                </>
            }
        </div>
    )
}

export default AdminProtectedRoutes